import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";

import HomeBanner from "../components/HomeBanner";
import Menu from "../components/HomeMenu";
import "./Home.css";

import { Helmet } from "react-helmet-async";
import Testimonial from "../components/Testimonial";
import Connect from "../components/Connect";
import HomeAbout from "../components/HomeAbout";
import Gallery from "../components/Gallery";
import Provide from "../components/Provide";
import Special from "../components/Special";
import Staff from "../components/Staff";
// import BookingForm from "../components/BookingForm";
// import WhyUS from "../components/WhyUS";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 100,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

const Home = () => {
  const location = useLocation();

  // ✅ Navbar se kisi doosre route se navigate hone par scroll handle karega
  useEffect(() => {
    if (location.state?.scrollTo) {
      const timer = setTimeout(() => {
        const section = document.getElementById(location.state.scrollTo);
        if (section) {
          section.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <>
         <Helmet>
        <title>Khasiyat Restaurant | Pure Veg Restaurant in Pahalgam</title>
        <meta
          name="description"
          content="Khasiyat is a pure veg restaurant in Pahalgam offering authentic multi-cuisine food, family dining, cafe, and special local cuisine near Pahalgam market."
        />
        <meta
          name="keywords"
          content="pure veg restaurant in Pahalgam, best restaurant Pahalgam, veg food Pahalgam, family restaurant Pahalgam, cafe in Pahalgam, Khasiyat restaurant"
        />
        <link rel="canonical" href="https://khasiyatrestaurant.com/" />
      </Helmet>

      {/* ✅ SEO hidden heading — crawlable, not visible */}
      <h1 className="visually-hidden">
        Khasiyat – Pure Veg Restaurant in Pahalgam
      </h1>
      <h2 className="visually-hidden">
        Best Family Dining and Multi-Cuisine Veg Food in Pahalgam
      </h2>

      {/* ✅ HOME */}
      <motion.section
        id="home"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <HomeBanner />
      </motion.section>

      {/* ✅ ABOUT */}
      <motion.section
        id="about"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <HomeAbout />
      </motion.section>

      <motion.section
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Provide />
      </motion.section>
      {/*  */}
      <motion.section
        id="quality"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Special />
      </motion.section>
      {/*  */}
      {/* <motion.section
        id="quality"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <WhyUS />
      </motion.section> */}

      {/* ✅ MENU */}
      <motion.section
        id="menu"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Menu />
      </motion.section>

      <motion.section
        id="staff"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Staff />
      </motion.section>

      {/* ✅ REVIEW */}
      <motion.section
        id="review"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Testimonial />
      </motion.section>

      {/* ✅ CONTACT */}
      <motion.section
        id="connect"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Connect />
      </motion.section>

      {/* ✅ GALLERY */}
      <motion.section
        id="gallery"
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        <Gallery />
      </motion.section>
    </>
  );
};

export default Home;